/* ECOM VENOM — theme runtime (no dependencies) */
(() => {
  const EV = window.EV || { routes: { root: '/', cart: '/cart' }, cartBehavior: 'drawer', strings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (EV.routes.root || '/').replace(/\/?$/, '/');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- focus trap ---------- */
  const focusables = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  function trap(container, e) {
    if (e.key !== 'Tab') return;
    const items = $$(focusables, container).filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  }

  /* ---------- mobile menu ---------- */
  const menu = $('[data-ev-menu]');
  const menuBtn = $('[data-ev-menu-open]');
  let lastFocus = null;
  function openMenu() {
    if (!menu) return;
    lastFocus = document.activeElement;
    menu.hidden = false;
    requestAnimationFrame(() => menu.classList.add('is-open'));
    menuBtn && menuBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('ev-lock');
    const c = $('[data-ev-menu-close]', menu); c && c.focus();
  }
  function closeMenu() {
    if (!menu || !menu.classList.contains('is-open')) return;
    menu.classList.remove('is-open');
    menuBtn && menuBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('ev-lock');
    setTimeout(() => { menu.hidden = true; }, 300);
    lastFocus && lastFocus.focus();
  }
  menuBtn && menuBtn.addEventListener('click', openMenu);
  if (menu) {
    $$('[data-ev-menu-close], [data-ev-menu-link]', menu).forEach((el) => el.addEventListener('click', closeMenu));
    menu.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); trap(menu, e); });
  }

  /* ---------- cart drawer ---------- */
  const drawer = $('[data-ev-drawer]');
  function openDrawer() {
    if (!drawer) { window.location.href = EV.routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ev-lock');
    setTimeout(() => { const p = $('.ev-drawer__panel', drawer); p && p.focus(); }, 60);
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ev-lock');
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  if (drawer) {
    drawer.addEventListener('click', (e) => { if (e.target.closest('[data-ev-drawer-close]')) closeDrawer(); });
    drawer.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); trap($('.ev-drawer__panel', drawer), e); });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-ev-cart-open]');
    if (opener && drawer && !document.body.classList.contains('ev-template--cart')) { e.preventDefault(); openDrawer(); }
  });

  async function refreshCart() {
    try {
      const res = await fetch(`${root}?sections=ev-cart-drawer`, { headers: { Accept: 'application/json' } });
      const data = await res.json();
      const html = data['ev-cart-drawer'];
      if (html && drawer) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('[data-ev-drawer-content]', doc);
        const current = $('[data-ev-drawer-content]', drawer);
        if (fresh && current) current.replaceWith(fresh);
      }
      const cart = await (await fetch(`${root}cart.js`)).json();
      $$('[data-ev-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      $$('[data-ev-cart-label]').forEach((el) => el.setAttribute('aria-label', `${el.dataset.evCartLabel} — ${cart.item_count}`));
      return cart;
    } catch (err) { console.warn('[ev] cart refresh failed', err); return null; }
  }

  /* Digital course: quantity is pinned to 1 (idempotent add). */
  async function addCourse(btn) {
    const id = btn.getAttribute('data-ev-add');
    const mode = btn.getAttribute('data-ev-mode') || EV.cartBehavior || 'drawer';
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: { [id]: 1 } })
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      await refreshCart();
      if (mode === 'checkout') {
        const checkout = $('[data-ev-whatsapp-checkout]', drawer || document);
        window.location.href = checkout ? checkout.href : EV.routes.cart;
        return;
      }
      openDrawer();
    } catch (err) {
      console.warn('[ev] add failed', err);
      window.location.href = EV.routes.cart;
    } finally {
      btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-ev-add]');
    if (add) { e.preventDefault(); addCourse(add); return; }
    const rm = e.target.closest('[data-ev-remove]');
    if (rm) {
      e.preventDefault();
      rm.disabled = true;
      fetch(`${root}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: rm.getAttribute('data-ev-remove'), quantity: 0 })
      }).then(() => {
        if (document.body.classList.contains('ev-template--cart')) window.location.reload();
        else refreshCart();
      });
    }
  });

  /* Product form (native form, enhanced) */
  $$('form[data-ev-product-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      const btn = form.querySelector('[data-ev-add]');
      if (!btn) return;
      e.preventDefault();
      addCourse(btn);
    });
  });

  /* ---------- video players ---------- */
  const fmt = (t) => { if (!isFinite(t)) return '0:00'; const m = Math.floor(t / 60); const s = Math.floor(t % 60); return `${m}:${String(s).padStart(2, '0')}`; };
  function initVslPlayer(player, video, playBtn) {
    const bar = $('[data-ev-bar]', player);
    const toggle = $('[data-ev-toggle]', player);
    const seek = $('[data-ev-seek]', player);
    const time = $('[data-ev-time]', player);
    const mute = $('[data-ev-mute]', player);
    const fs = $('[data-ev-fs]', player);
    const status = $('[data-ev-status]', player);
    const labels = player.dataset;
    const native = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    let started = false;
    let requested = false;
    player.classList.add('is-enhanced');
    player.classList.toggle('is-native', native);
    video.controls = false;
    const message = (text = '') => {
      status.textContent = text;
      status.hidden = !text;
      player.setAttribute('aria-busy', String(text === labels.loadingLabel));
    };
    const sync = () => {
      const playing = !video.paused && !video.ended;
      player.classList.toggle('is-playing', playing);
      player.classList.toggle('is-muted', video.muted || video.volume === 0);
      toggle.setAttribute('aria-label', playing ? labels.pauseLabel : labels.playLabel);
      mute.setAttribute('aria-label', video.muted || video.volume === 0 ? labels.unmuteLabel : labels.muteLabel);
      mute.setAttribute('aria-pressed', String(video.muted || video.volume === 0));
      const duration = Number.isFinite(video.duration) ? video.duration : 0;
      seek.disabled = !duration;
      seek.value = duration ? Math.round(video.currentTime / duration * 1000) : 0;
      seek.style.setProperty('--p', `${Number(seek.value) / 10}%`);
      seek.setAttribute('aria-valuetext', `${fmt(video.currentTime)} / ${fmt(duration)}`);
      time.textContent = `${fmt(video.currentTime)} / ${fmt(duration)}`;
    };
    const failed = () => {
      requested = false;
      video.pause();
      player.classList.remove('is-playing');
      if (!started) player.classList.remove('is-started');
      playBtn.hidden = false;
      playBtn.setAttribute('aria-label', labels.playLabel);
      bar.hidden = native || !started;
      message(labels.errorLabel);
      sync();
    };
    const start = async (autoplay = false) => {
      if (requested && !video.paused) return;
      requested = true;
      if (video.error) video.load();
      if (video.ended) video.currentTime = 0;
      if (!started) { video.muted = autoplay; video.volume = 1; }
      if (native) video.controls = true;
      message(labels.loadingLabel);
      try { await video.play(); }
      catch (error) {
        if (error.name === 'AbortError' && !requested) return;
        failed();
        if (autoplay && error.name === 'NotAllowedError') message();
      }
    };
    const pauseOrPlay = () => {
      if (video.paused || video.ended) start();
      else { requested = false; video.pause(); }
    };
    const fullscreen = async () => {
      try {
        if (document.fullscreenElement) await document.exitFullscreen();
        else if (player.requestFullscreen) await player.requestFullscreen();
        else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
      } catch (error) {
        video.controls = true;
        player.classList.add('is-native');
        bar.hidden = true;
      }
    };
    const changeTime = (seconds) => {
      if (Number.isFinite(video.duration)) video.currentTime = Math.min(video.duration, Math.max(0, seconds));
    };
    playBtn.addEventListener('click', () => start());
    toggle.addEventListener('click', pauseOrPlay);
    if (!native) video.addEventListener('click', pauseOrPlay);
    video.addEventListener('playing', () => {
      const moveFocus = document.activeElement === playBtn;
      started = true;
      player.classList.add('is-started');
      playBtn.hidden = true;
      bar.hidden = native;
      message();
      sync();
      if (moveFocus) (native ? video : toggle).focus({ preventScroll: true });
    });
    video.addEventListener('pause', () => { requested = false; message(); sync(); });
    video.addEventListener('waiting', () => { if (requested && !video.paused) message(labels.loadingLabel); });
    video.addEventListener('seeking', () => { if (started) message(labels.loadingLabel); });
    video.addEventListener('seeked', () => { message(); sync(); });
    video.addEventListener('error', failed);
    video.addEventListener('ended', () => {
      requested = false;
      message();
      sync();
      playBtn.hidden = false;
      playBtn.setAttribute('aria-label', labels.replayLabel);
    });
    ['timeupdate', 'loadedmetadata', 'durationchange', 'volumechange'].forEach((event) => video.addEventListener(event, sync));
    seek.addEventListener('input', () => { changeTime(Number(seek.value) / 1000 * video.duration); sync(); });
    mute.addEventListener('click', () => {
      if (video.volume === 0) { video.volume = 1; video.muted = false; }
      else video.muted = !video.muted;
      sync();
    });
    fs.addEventListener('click', fullscreen);
    player.addEventListener('keydown', (event) => {
      // Native buttons and the LTR range retain their standard Enter/Space/arrow behavior.
      if (native || event.target !== video) return;
      if ([' ', 'k', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'm', 'f'].includes(event.key)) event.preventDefault();
      if (event.key === ' ' || event.key === 'k') pauseOrPlay();
      if (event.key === 'ArrowLeft') changeTime(video.currentTime - 5);
      if (event.key === 'ArrowRight') changeTime(video.currentTime + 5);
      if (event.key === 'ArrowUp') video.volume = Math.min(1, video.volume + 0.1);
      if (event.key === 'ArrowDown') video.volume = Math.max(0, video.volume - 0.1);
      if (event.key === 'm') mute.click();
      if (event.key === 'f') fullscreen();
    });
    sync();
    if (video.autoplay) start(true);
  }
  function embedUrl(url) {
    try {
      const u = new URL(url);
      if (u.hostname.includes('youtu')) {
        const id = u.hostname.includes('youtu.be') ? u.pathname.slice(1) : (u.searchParams.get('v') || u.pathname.split('/').pop());
        return `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
      }
      if (u.hostname.includes('vimeo')) return `https://player.vimeo.com/video/${u.pathname.split('/').filter(Boolean).pop()}?autoplay=1&title=0&byline=0&portrait=0`;
    } catch (e) { /* ignore */ }
    return url;
  }
  $$('[data-ev-player]').forEach((player) => {
    const video = $('[data-ev-video]', player);
    const playBtn = $('[data-ev-play]', player);
    const embed = $('[data-ev-embed]', player);
    if (!playBtn) return;
    if (embed && !video) {
      playBtn.addEventListener('click', () => {
        const iframe = document.createElement('iframe');
        iframe.src = embedUrl(embed.getAttribute('data-ev-embed'));
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = playBtn.getAttribute('aria-label') || 'Video';
        embed.appendChild(iframe);
        player.classList.add('is-playing', 'is-embed');
      });
      return;
    }
    if (!video) return;
    if (player.hasAttribute('data-ev-vsl')) { initVslPlayer(player, video, playBtn); return; }
    const bar = $('[data-ev-bar]', player);
    const toggle = $('[data-ev-toggle]', player);
    const seek = $('[data-ev-seek]', player);
    const time = $('[data-ev-time]', player);
    const mute = $('[data-ev-mute]', player);
    const fs = $('[data-ev-fs]', player);
    const start = () => { player.classList.add('is-started'); bar && (bar.hidden = false); video.play(); };
    playBtn.addEventListener('click', start);
    video.addEventListener('click', () => (video.paused ? video.play() : video.pause()));
    toggle && toggle.addEventListener('click', () => (video.paused ? video.play() : video.pause()));
    video.addEventListener('play', () => player.classList.add('is-playing'));
    video.addEventListener('pause', () => player.classList.remove('is-playing'));
    video.addEventListener('timeupdate', () => {
      if (seek && video.duration) seek.value = Math.round((video.currentTime / video.duration) * 1000);
      if (time) time.textContent = `${fmt(video.currentTime)} / ${fmt(video.duration)}`;
      seek && seek.style.setProperty('--p', `${(video.currentTime / (video.duration || 1)) * 100}%`);
    });
    seek && seek.addEventListener('input', () => { if (video.duration) video.currentTime = (seek.value / 1000) * video.duration; });
    mute && mute.addEventListener('click', () => { video.muted = !video.muted; player.classList.toggle('is-muted', video.muted); });
    fs && fs.addEventListener('click', () => {
      const el = player;
      if (document.fullscreenElement) document.exitFullscreen();
      else if (el.requestFullscreen) el.requestFullscreen();
      else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
    });
  });

  /* ---------- accordions: one open at a time per group ---------- */
  $$('[data-ev-accordion]').forEach((group) => {
    const items = $$('details', group);
    items.forEach((d) => d.addEventListener('toggle', () => {
      if (d.open && group.hasAttribute('data-ev-single')) items.forEach((o) => { if (o !== d) o.open = false; });
    }));
  });

  /* ---------- FAQ filter ---------- */
  $$('[data-ev-faq]').forEach((wrap) => {
    const input = $('[data-ev-faq-search]', wrap);
    const chips = $$('[data-ev-faq-cat]', wrap);
    const items = $$('[data-ev-faq-item]', wrap);
    const empty = $('[data-ev-faq-empty]', wrap);
    let cat = 'all';
    const norm = (s) => (s || '').toLowerCase().replace(/[ً-ْ]/g, '').replace(/[أإآ]/g, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي');
    const apply = () => {
      const q = norm(input ? input.value.trim() : '');
      let shown = 0;
      items.forEach((it) => {
        const okCat = cat === 'all' || it.getAttribute('data-ev-faq-item') === cat;
        const okQ = !q || norm(it.textContent).includes(q);
        it.hidden = !(okCat && okQ);
        if (!it.hidden) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
    };
    input && input.addEventListener('input', apply);
    chips.forEach((c) => c.addEventListener('click', () => {
      cat = c.getAttribute('data-ev-faq-cat');
      chips.forEach((o) => o.setAttribute('aria-pressed', String(o === c)));
      apply();
    }));
  });

  /* ---------- legal TOC (auto from headings) ---------- */
  $$('[data-ev-autotoc]').forEach((toc) => {
    const body = document.getElementById(toc.getAttribute('data-ev-autotoc'));
    if (!body) return;
    const hs = $$('h2, h3', body);
    if (!hs.length) { toc.closest('[data-ev-toc-wrap]') && (toc.closest('[data-ev-toc-wrap]').hidden = true); return; }
    hs.forEach((h, i) => {
      if (!h.id) h.id = `ev-sec-${i + 1}`;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${h.id}`; a.textContent = h.textContent;
      li.appendChild(a); toc.appendChild(li);
    });
  });

  /* ---------- sticky CTA ---------- */
  const sticky = $('[data-ev-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    const hide = new Set();
    let pastHero = false;
    const hero = $('[data-ev-hero]');
    const update = () => sticky.classList.toggle('is-visible', pastHero && hide.size === 0);
    if (hero) new IntersectionObserver(([en]) => { pastHero = !en.isIntersecting && en.boundingClientRect.top < 0; update(); }).observe(hero);
    else pastHero = true;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { en.isIntersecting ? hide.add(en.target) : hide.delete(en.target); });
      update();
    }, { rootMargin: '0px 0px -10% 0px' });
    $$('[data-ev-sticky-hide], .ev-footer').forEach((el) => io.observe(el));
  }


  /* ---------- scroll-linked engine ----------
     [data-ev-scroll="pin"]     --p = progress through a sticky track (section height − viewport)
     [data-ev-scroll="view"]    --p = 0 when the top enters the viewport bottom → 1 when it reaches the top
     [data-ev-scroll="through"] --p = 0 entering → 1 fully left
     [data-ev-steps="n"]        also exposes data-ev-active = current step (0..n-1)
     [data-ev-hscroll]          exposes --dist = horizontal overflow of [data-ev-htrack] (px)
     Reduced motion: everything resolves to its final, static state. */
  const scrollEls = $$('[data-ev-scroll]');
  if (reduceMotion) document.documentElement.classList.add('ev-rm');
  if (scrollEls.length) {
    let ticking = false;
    const measure = () => {
      $$('[data-ev-hscroll]').forEach((el) => {
        const track = $('[data-ev-htrack]', el);
        if (track) el.style.setProperty('--dist', `${Math.max(0, track.scrollWidth - el.clientWidth)}px`);
      });
    };
    const update = () => {
      const vh = window.innerHeight;
      scrollEls.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -vh || r.top > vh * 2) return;
        const mode = el.getAttribute('data-ev-scroll');
        let p;
        if (reduceMotion) p = 1;
        else if (mode === 'pin') p = -r.top / Math.max(1, r.height - vh);
        else if (mode === 'through') p = (vh - r.top) / (vh + r.height);
        else p = (vh - r.top) / vh;
        p = Math.min(1, Math.max(0, p));
        el.style.setProperty('--p', p.toFixed(4));
        const n = +el.getAttribute('data-ev-steps');
        if (n) {
          const i = String(Math.min(n - 1, Math.floor(p * n * 0.9999)));
          if (el.getAttribute('data-ev-active') !== i) {
            el.setAttribute('data-ev-active', i);
            const a = +i;
            el.querySelectorAll('[data-i]').forEach((c) => {
              const k = +c.getAttribute('data-i');
              c.classList.toggle('is-active', k === a);
              c.classList.toggle('is-past', k < a);
            });
            el.querySelectorAll('[data-ev-count]').forEach((c) => { c.textContent = String(a + 1).padStart(2, '0'); });
          }
        }
      });
      ticking = false;
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => { measure(); onScroll(); });
    window.addEventListener('load', () => { measure(); update(); });
    measure(); update();
    /* step dots / layer buttons jump to their step inside a pinned chapter */
    $$('[data-ev-goto]').forEach((b) => b.addEventListener('click', () => {
      const host = b.closest('[data-ev-scroll="pin"]');
      if (!host) return;
      const n = +host.getAttribute('data-ev-steps') || 1;
      const i = +b.getAttribute('data-ev-goto');
      const top = host.getBoundingClientRect().top + window.scrollY;
      const span = host.offsetHeight - window.innerHeight;
      window.scrollTo({ top: top + span * ((i + 0.5) / n), behavior: reduceMotion ? 'auto' : 'smooth' });
    }));
  }

  /* header state over the cinematic hero */
  const setScrolled = () => document.body.classList.toggle('is-scrolled', window.scrollY > 40);
  window.addEventListener('scroll', setScrolled, { passive: true }); setScrolled();

  /* ---------- reveal ---------- */
  const reveals = $$('.ev-reveal, .ev-polish-reveal');
  if (document.body.hasAttribute('data-ev-no-motion') || reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach((el) => el.classList.add('is-in'));
  } else {
    const ro = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); ro.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach((el) => ro.observe(el));
  }

  /* ---------- horizontal scrollers: keyboard + buttons ---------- */
  $$('[data-ev-scroller]').forEach((wrap) => {
    const track = $('[data-ev-track]', wrap);
    if (!track) return;
    const step = () => Math.max(track.clientWidth * 0.8, 260);
    const dir = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
    $$('[data-ev-prev]', wrap).forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: -step() * dir, behavior: reduceMotion ? 'auto' : 'smooth' })));
    $$('[data-ev-next]', wrap).forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: step() * dir, behavior: reduceMotion ? 'auto' : 'smooth' })));
  });

  /* ---------- course player: hash-routed lessons, search, local notes ---------- */
  $$('[data-ev-lessons]').forEach((wrap) => {
    const items = $$('[data-ev-lesson]', wrap);
    if (!items.length) return;
    const links = $$('[data-ev-lesson-link]', wrap);
    const show = (n) => {
      items.forEach((it) => {
        const on = it.getAttribute('data-ev-lesson') === String(n);
        it.hidden = !on;
        if (!on) { const v = $('video', it); v && v.pause(); }
      });
      links.forEach((l) => l.classList.toggle('is-active', l.getAttribute('data-ev-lesson-link') === String(n) && l.closest('.ev-lesson__mod')));
      const active = links.find((l) => l.closest('.ev-lesson__mod') && l.getAttribute('data-ev-lesson-link') === String(n));
      if (active) { const d = active.closest('details'); d && (d.open = true); }
    };
    const fromHash = () => { const m = location.hash.match(/^#lesson-(\d+)$/); show(m ? m[1] : 1); };
    window.addEventListener('hashchange', fromHash);
    fromHash();
    const search = $('[data-ev-lesson-search]', wrap.ownerDocument);
    search && search.addEventListener('input', () => {
      const q = search.value.trim().toLowerCase();
      links.filter((l) => l.closest('.ev-lesson__mod')).forEach((l) => { l.parentElement.hidden = q && !l.textContent.toLowerCase().includes(q); });
      if (q) $$('.ev-lesson__mod', wrap).forEach((d) => { d.open = true; });
    });
    $$('[data-ev-notes]', wrap).forEach((ta) => {
      const key = `ev-notes-${ta.getAttribute('data-ev-notes')}`;
      try { ta.value = localStorage.getItem(key) || ''; } catch (e) { /* storage unavailable */ }
      ta.addEventListener('input', () => { try { localStorage.setItem(key, ta.value); } catch (e) { /* ignore */ } });
    });
  });

  /* login: reveal recover form when linked */
  $$('[data-ev-toggle-recover]').forEach((a) => a.addEventListener('click', () => setTimeout(() => { const i = $('#EvREmail'); i && i.focus(); }, 50)));

  /* Theme editor: keep drawer usable when selecting its section */
  document.addEventListener('shopify:section:select', (e) => { if (e.target.id && e.target.id.includes('ev-cart-drawer')) openDrawer(); });
  document.addEventListener('shopify:section:deselect', (e) => { if (e.target.id && e.target.id.includes('ev-cart-drawer')) closeDrawer(); });
  document.addEventListener('shopify:section:load', () => { $$('.ev-reveal, .ev-polish-reveal').forEach((el) => el.classList.add('is-in')); });
})();
